var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-banner-box"},[_c('img',{attrs:{"src":require("assets/images/information/banner-img.jpg"),"alt":""}}),_c('div',[_vm._v("通知公告")])])
}]

export { render, staticRenderFns }